import { createAction } from 'typesafe-actions';
import { IPump } from '../../../@types/model/borehole/pump';

export default class MasterDataPumpActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPS', resolve => (pumps : Array<IPump>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPS_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}